import { NgIf } from "@angular/common";
import { Component, Input } from "@angular/core";

import { AppBaseComponent } from "@app/shared/components/app-base.component";
import { CaseContextCriminalHistoryPanelComponent } from "../case-context-criminal-history-panel/case-context-criminal-history-panel.component";
import { CaseContextHearingHistoryPanelComponent } from "../case-context-hearing-history-panel/case-context-hearing-history-panel.component";
import { CaseContextIncarcerationHistoryPanelComponent } from "../case-context-incarceration-history-panel/case-context-incarceration-history-panel.component";
import { CaseContextInstitutionalConductPanelComponent } from "../case-context-institutional-conduct-panel/case-context-institutional-conduct-panel.component";
import { CaseContextOffensePanelComponent } from "../case-context-offense-panel/case-context-offense-panel.component";
import { CaseContextProgrammingPanelComponent } from "../case-context-programming-panel/case-context-programming-panel.component";
import { CaseContextViolationsPanelComponent } from "../case-context-violations-panel/case-context-violations-panel.component";

const INSTITUTIONAL_CONDUCT_READ_PERMISSION = "institutional_conduct_record.read";

@Component({
  selector: "phms-case-context-legal-records-tab",
  standalone: true,
  imports: [
    NgIf,
    CaseContextCriminalHistoryPanelComponent,
    CaseContextHearingHistoryPanelComponent,
    CaseContextIncarcerationHistoryPanelComponent,
    CaseContextInstitutionalConductPanelComponent,
    CaseContextOffensePanelComponent,
    CaseContextProgrammingPanelComponent,
    CaseContextViolationsPanelComponent,
  ],
  template: `
    <section class="case-context-tab case-context-tab--records" aria-label="Records, history, custody, conduct, and hearings">
      <phms-case-context-offense-panel
        class="case-context-tab__panel"
        [incarceratedPersonId]="incarceratedPersonId"
      ></phms-case-context-offense-panel>

      <div class="case-context-tab__grid case-context-tab__grid--two">
        <phms-case-context-violations-panel
          class="case-context-tab__panel"
          [incarceratedPersonId]="incarceratedPersonId"
        ></phms-case-context-violations-panel>

        <phms-case-context-programming-panel
          class="case-context-tab__panel"
          [incarceratedPersonId]="incarceratedPersonId"
        ></phms-case-context-programming-panel>
      </div>

      <phms-case-context-institutional-conduct-panel
        *ngIf="canReadInstitutionalConduct()"
        class="case-context-tab__panel"
        [incarceratedPersonId]="incarceratedPersonId"
      ></phms-case-context-institutional-conduct-panel>

      <div class="case-context-tab__grid case-context-tab__grid--custody-history">
        <phms-case-context-criminal-history-panel
          class="case-context-tab__panel"
          [incarceratedPersonId]="incarceratedPersonId"
        ></phms-case-context-criminal-history-panel>

        <phms-case-context-incarceration-history-panel
          class="case-context-tab__panel"
          [incarceratedPersonId]="incarceratedPersonId"
        ></phms-case-context-incarceration-history-panel>
      </div>

      <phms-case-context-hearing-history-panel
        class="case-context-tab__panel case-context-tab__panel--hearing-history"
        [incarceratedPersonId]="incarceratedPersonId"
      ></phms-case-context-hearing-history-panel>
    </section>
  `,
  styleUrl: "./case-context-tab-layout.scss",
})
export class CaseContextLegalRecordsTabComponent extends AppBaseComponent {
  @Input({ required: true }) incarceratedPersonId!: number;

  canReadInstitutionalConduct(): boolean {
    return this.roles.hasAnyPermission(INSTITUTIONAL_CONDUCT_READ_PERMISSION);
  }
}
